import { useEffect } from "react";
import { useSelector } from "react-redux";
import socket from "../config/socket/index.js";

const useUpdateLocation = () => {
  const token = useSelector((state) => state.user.userToken);
  const chauffeurId = useSelector((state) => state.user.userData?._id);
  const isOnline = useSelector((state) => state.user.userData?.isOnline);
  const isRiding = useSelector((state) => state.ride.riding);
  useEffect(() => {
    if (isOnline && !isRiding) {
      const updateLocation = () => {
        console.log("Update Location is running");
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const coordinates = [
                position.coords.longitude,
                position.coords.latitude,
              ];
              socket.emit("changeMyLocation", { chauffeurId, coordinates });
            },
            (error) => {
              console.error("Error fetching location", error);
            }
          );
        } else {
          console.error("Geolocation is not supported by this browser.");
        }
      };

      updateLocation(); // run once at the start
 

      // Update location every minute
      const intervalId = setInterval(updateLocation, 120000);

      // Perform cleanup
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [chauffeurId, isOnline, token, isRiding]);
};

export default useUpdateLocation;
